/**
 * Default `eventStyleResolver` for `<PooCalendar>` — provider scope.
 *
 * Given a booking, returns the metadata `<PooCalendar>` needs to style
 * one event pill:
 *
 *   { statusClass: "rbc-evt-accepted" | "rbc-evt-in-progress"
 *                | "rbc-evt-completed" | "rbc-evt-payment-pending",
 *     accentColor?: undefined,        // admin scope only — see below
 *     chipLabel?:   undefined,        // admin scope only — see below
 *     extraClass?:  undefined }
 *
 * Exported as a module-level singleton so callers can drop it into
 * `<PooCalendar eventStyleResolver={defaultProviderResolver}>` without
 * forcing a fresh `useMemo` invalidation on every render. (See
 * Step 1 §6 R2 — inline arrows blow up the events memo key.)
 *
 * Admin scope will ship its own resolver (`useAdminEventStyle.js`) in
 * Backlog E. It returns:
 *
 *   { statusClass, accentColor: "#7B68EE", chipLabel: "Plucky's Crew" }
 *
 * `<PooCalendar>` consumes both shapes identically — provider scope
 * just leaves `accentColor` + `chipLabel` undefined and the calendar
 * falls back to the bare status pill.
 */

export const STATUS_CLASS = {
  payment_pending: "rbc-evt-payment-pending",
  accepted: "rbc-evt-accepted",
  in_progress: "rbc-evt-in-progress",
  completed: "rbc-evt-completed",
};

export function defaultProviderResolver(booking) {
  return { statusClass: STATUS_CLASS[booking?.status] || "" };
}
